"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = void 0;

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas-lab/typography");

var _styleUtilities = require("@creditas-lab/style-utilities");

const Description = (0, _stylitas.styled)(_typography.Typography)`
  width: 80%;
  line-height: 20px;

  ${_styleUtilities.media.md`
    line-height: 24px;
  `}
`;
exports.Description = Description;